import React from 'react';
import * as PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core';
import MailDraftHeader from './MailDraftHeader';
import MailDraftContent from './MailDraftContent';
import MailDraftActions from './MailDraftActions';
import { IdPropType } from '../../../proptypes/basic';
import { useEmailDraft } from '../emailDraftsSlice';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
    },

    header: {
        height: theme.spacing(12),
        width: '100%',
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        overflow: 'hidden',
        flexShrink: 0,
    },

    content: {
        flexGrow: 1,
        overflowY: 'auto',
        background: '#f7f7f7',
    },

    actions: {
        height: theme.spacing(8),
        width: '100%',
        borderTop: `1px solid ${theme.palette.grey[300]}`,
        overflow: 'hidden',
        flexShrink: 0,
    },
}));

const MailDraftView = ({ customerId, draftId, popup, onDeleted, onSent, onCloseWithoutSent }) => {
    const classes = useStyles();
    const [draft] = useEmailDraft(draftId);

    return (
        <Box className={classes.root}>
            <Box className={classes.header}>
                {draft && <MailDraftHeader draftId={draftId} customerId={draft.customer_id} popup={popup} />}
            </Box>
            <Box className={classes.content}>
                <MailDraftContent draftId={draftId} />
            </Box>
            <Box className={classes.actions}>
                <MailDraftActions 
                    draftId={draftId} 
                    onDeleted={onDeleted} 
                    onSent={onSent}
                    onCloseWithoutSent={onCloseWithoutSent}
                />
            </Box>
        </Box>
    );
};

MailDraftView.propTypes = {
    draftId: IdPropType,
    popup: PropTypes.bool,
    customerId: IdPropType,
    onDeleted: PropTypes.func.isRequired,
    onSent: PropTypes.func.isRequired,
    onCloseWithoutSent: PropTypes.func.isRequired,
};

MailDraftView.defaultProps = {
    draftId: null,
    popup: false,
    customerId: null,
    onDeleted: null,
    onSent: null,
    onCloseWithoutSent: null,
};

export default MailDraftView;
